:host {
  display: block;
  color: var(--lgr-color-neutral-low-pure);
  font-family: var(--lgr-font-family-regular);

  button {
    display: inline-flex;
    align-items: baseline;
    justify-content: space-between;
    width: 100%;
    padding: 0 var(--lgr-spacing-quarck) var(--lgr-spacing-nano) 0;
    border: none;
    border-bottom: 2px solid var(--lgr-color-neutral-low-pure);
    background: none;
    color: var(--lgr-color-neutral-low-pure);
    text-align: justify;
    cursor: pointer;

    h2 {
      margin: 0;
      font-family: var(--lgr-font-family-bold);
      font-size: var(--lgr-font-size-lg);
    }

    &:hover {
      border-color: var(--lgr-color-brand-primary-dark);
      color: var(--lgr-color-brand-primary-dark);

      lgr-icon {
        color: var(--lgr-color-brand-primary-dark);
      }
    }

    &:active {
      border-color: var(--lgr-color-brand-primary-light);
      color: var(--lgr-color-brand-primary-light);

      lgr-icon {
        color: var(--lgr-color-brand-primary-light);
      }
    }

    &:disabled {
      border-color: var(--lgr-color-neutral-low-light);
      color: var(--lgr-color-neutral-low-light);

      lgr-icon {
        color: var(--lgr-color-neutral-low-light);
      }
    }

    &.inverse {
      border-color: var(--lgr-color-neutral-high-pure);
      color: var(--lgr-color-neutral-high-pure);

      &:hover {
        opacity: var(--lgr-alpha-intense);
      }

      &:active {
        opacity: 1;
      }

      &:disabled {
        opacity: var(--lgr-alpha-intense);
      }
    }
    &.closed-gray {
      border-color: var(--lgr-color-neutral-low-medium);
      color: var(--lgr-color-neutral-low-medium);

      svg {
        path {
          fill: var(--lgr-color-neutral-low-medium);
        }
      }
      &.lgr-open-accordion {
        border-color: var(--lgr-color-neutral-low-pure);
        color: var(--lgr-color-neutral-low-pure);

        svg {
          path {
            fill: var(--lgr-color-neutral-low-pure);
          }
        }
      }
    }
  }


  .lgr-accordion-content {
    height: 0;
    margin: var(--lgr-spacing-nano) 0 var(--lgr-spacing-xs);
    padding: 0 var(--lgr-spacing-quarck);
    overflow: hidden;
    color: var(--lgr-color-neutral-low-dark);

    &.lgr-open-accordion {
      height: 100%;
    }

    &.inverse {
      color: var(--lgr-color-neutral-high-pure);
      svg {
        path {
          fill: var(--lgr-color-neutral-high-pure);
        }
      }

      &.disabled {
        opacity: var(--lgr-alpha-intense);
        svg {
          path {
            fill: var(--lgr-color-neutral-high-pure);
          }
        }
      }
    }

    &.disabled {
      color: var(--lgr-color-neutral-low-light);
      svg {
        path {
          fill: var(--lgr-color-neutral-low-light);
        }
      }
    }
  }

  .lgr-accordion-expand-icon {
    display: flex;
    position: relative;
    top: var(--lgr-spacing-quarck);
    margin-left: var(--lgr-spacing-quarck);
    transition: all 250ms;
    color: var(--lgr-color-neutral-low-pure);
    font-size: var(--lgr-font-size-xl);
    pointer-events: none;

    & > span {
      display: none;
    }

    &.disabled {
      color: var(--lgr-color-neutral-low-light);
      svg {
        path {
          fill: var(--lgr-color-neutral-low-light);
        }
      }
    }

    &.lgr-open-accordion {
      transform: rotate(180deg);
    }

    &.lgr-closed-accordion {
      transform: rotate(0deg);
    }

    &.inverse {
      color: var(--lgr-color-neutral-high-pure);
      svg {
        path {
          fill: var(--lgr-color-neutral-high-pure);
        }
      }
    }
  }
}